export function syncRender() {
    const exist = document.body.classList.contains('sync-render');
    !exist && document.body.classList.add('sync-render');
}
